import DOMPurify from "dompurify";
import React from "react";
import { renderToString } from "react-dom/server";
import ArrowRight from '../../assets/arrow-right.svg?react';

export interface MegaMenuPreviewItemProps {
  title: string,
  imageUrl: string,
  introductionText: string;
  text: string;
  id: number;
}

const localPurifier = DOMPurify();

export const MegaMenuPreviewItem: React.FC<MegaMenuPreviewItemProps> = (props) => {

  localPurifier.addHook('beforeSanitizeAttributes', (node) => {
    if (node.nodeName && node.nodeName === 'P') {
      node.setAttribute('class', 'flex justify-between py-2 items-center border-t last-of-type:border-b border-primary group');
      const hasSvgChild = Array.from(node.childNodes).filter(child => child.nodeName === 'SPAN').length > 0;
      const hasLinkChildren = Array.from(node.childNodes).filter(child => child.nodeName === 'A').length > 0;

      if (!hasSvgChild && hasLinkChildren) {
        const icon = renderToString(<span className="mr-2 group-hover:translate-x-2 transition-all ease-out"><ArrowRight /></span>);
        node.innerHTML += icon;
      }
    }
    if (node.nodeName && node.nodeName === 'A') {
      node.setAttribute('class', 'text-primary');
    }
  });

  return (
    <div className="text-primary md:mr-4">
      <div className="bg-secondaryLightGreen">
        <div className="p-5">
          <div className="text-2xl mb-5">
            { props.title }
          </div>
          <div className="text-base">
            { props.introductionText }
          </div>
        </div>
        <img
          className="object-cover max-h-[181px] w-full mb-5"
          src={props.imageUrl}
        />
      </div>
      <div dangerouslySetInnerHTML={{ __html: localPurifier.sanitize(props.text) }}/>
    </div>
  );
};
